import i18n from 'i18next';
import { PUBLIC_WEB_URL } from '@/config/env';

/**
 * Build the customer-facing URL for an ad. Routes match the landing site:
 *   ROOM_AD         → /{locale}/rooms/{id}
 *   ROOM_WANTED_AD  → /{locale}/roommates/{id}
 *
 * Locale follows the active i18n language. Defaults to 'ar' to match
 * landing's default locale.
 */
export type PublicAdType = 'ROOM_AD' | 'ROOM_WANTED_AD';

function activeLocale(): 'ar' | 'en' {
  const lang = (i18n.resolvedLanguage || i18n.language || 'ar').toLowerCase();
  return lang.startsWith('en') ? 'en' : 'ar';
}

export function publicAdUrl(type: PublicAdType, id: number | string, locale?: 'ar' | 'en'): string {
  const l = locale ?? activeLocale();
  const path = type === 'ROOM_AD' ? `rooms/${id}` : `roommates/${id}`;
  return `${PUBLIC_WEB_URL.replace(/\/$/, '')}/${l}/${path}`;
}

export function publicRoomAdUrl(id: number | string, locale?: 'ar' | 'en'): string {
  return publicAdUrl('ROOM_AD', id, locale);
}

export function publicRoomWantedUrl(id: number | string, locale?: 'ar' | 'en'): string {
  return publicAdUrl('ROOM_WANTED_AD', id, locale);
}
